// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"378":"tokenInfoList","655":"marketCategory","678":"chainInfoList"}[chunkId] || chunkId) + "." + {"76":"68b3679d","378":"a65af355","473":"ff0a9407","655":"b170c5b5","678":"547160f2","945":"6b50ae3b"}[chunkId] + ".css";
};